import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useRouter } from "expo-router";

import AccountAvatarImage from "./AccountAvatarImage";

import AttributeTag from "@/Components/Cards/AttributeTag";
import { type AppUserSession } from "@/schemas/auth/session";
import { type UserProfile } from "@/schemas/user/profile";
import { useAvatarUpload } from "@/hooks/media";

type MetaProps = {
  session: AppUserSession;
  profile: UserProfile;
};

function AccountAvatar({ session, profile }: MetaProps): React.JSX.Element {
  const router = useRouter();
  const { isLoading, pickAndUploadImageAsAvatar } = useAvatarUpload(session);

  const handleFollowerPress = (): void => {
    router.push({
      params: { username: session.identity.username },
      pathname: "/(main)/shared/followers",
    });
  };

  const handleFollowingPress = (): void => {
    router.push({
      params: { username: session.identity.username },
      pathname: "/(main)/shared/followings",
    });
  };

  return (
    <View style={styles.layout}>
      <TouchableOpacity
        onPress={() => pickAndUploadImageAsAvatar()}
        disabled={isLoading}
      >
        <AccountAvatarImage
          avatar={session.identity.avatar}
          size={150}
          onUploadPress={() => pickAndUploadImageAsAvatar()}
          isUploading={isLoading}
          completionPercentage={100}
        />
      </TouchableOpacity>
      <Text style={styles.username}>@{session.identity.username}</Text>
      <View style={styles.tagsContainer}>
        <View style={styles.tagRow}>
          <AttributeTag
            icon="people"
            iconColor="#2ECC71"
            text={`${profile.followerCount} Followers`}
            backgroundColor="#2C3E50"
            onPress={handleFollowerPress}
          />
          <AttributeTag
            icon="people-outline"
            iconColor="#F39C12"
            text={`${profile.followingCount} Followings`}
            backgroundColor="#2C3E50"
            onPress={handleFollowingPress}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  layout: {
    alignItems: "center",
    marginTop: -10,
  },
  username: {
    color: "#ffffff",
    fontSize: 20,
    fontWeight: "bold",
    marginTop: 5,
  },
  tagRow: {
    flexDirection: "row",
    justifyContent: "center",
  },
  tagsContainer: {
    marginVertical: 12,
    width: "100%",
  },
});

export default AccountAvatar;
